/* eslint-disable */
/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @material-ui core components
import Card from "@mui/material/Card";
import PropTypes from "prop-types";

// Components
import Box from "components/Atoms/Box";
import Typography from "components/Atoms/Typography";

function LoadingCard({ title }) {
  return (
    <Card id="basic-info" className="overflow-visible">
      <Box p={3}>
        <Typography variant="h5">{title}</Typography>
        <h5>Loading...</h5>
      </Box>
    </Card>
  );
}

LoadingCard.defaultProps = { title: "" };

LoadingCard.propTypes = {
  title: PropTypes.string,
};

export default LoadingCard;
